/**
 * Extensions API Page
 * Public endpoint for IDE to fetch marketplace extensions
 * URL: /api/extensions
 */

import { useEffect, useState } from 'react';
import { getExtensionsAPIResponse, type ExtensionAPIResponse } from '@/api/extensions';

export function ExtensionsAPI() {
  const [response, setResponse] = useState<ExtensionAPIResponse | null>(null);

  useEffect(() => {
    // Get the API response
    const data = getExtensionsAPIResponse();
    setResponse(data);

    // Also store in localStorage for persistence
    localStorage.setItem('ochtopus-marketplace-api', JSON.stringify(data));
  }, []);

  if (!response) {
    return <div>Loading...</div>;
  }

  return (
    <pre
      style={{
        fontFamily: 'monospace',
        fontSize: '12px',
        padding: '20px',
        backgroundColor: '#0a0a0b',
        color: '#e5e5e5',
        overflow: 'auto',
        minHeight: '100vh',
      }}
    >
      {JSON.stringify(response, null, 2)}
    </pre>
  );
}

export default ExtensionsAPI;
